import { AutogenModelPnnLane, AutogenRowPnnLane } from "./autogen/AutogenModelPnnLane";

export class ModelPnnLane extends AutogenModelPnnLane<RowPnnLane> {
	constructor() {
		super(RowPnnLane);
	}
}

export class RowPnnLane extends AutogenRowPnnLane {
}